<template>
  <div class="booked-ancillaries">
    <div
      v-for="traveler in travelers_with_ancillaries"
      :key="`${_uid}:traveler:${traveler.id}`"
      class="booked-ancillaries__item"
    >
      <traveler-label :traveler_info="traveler" use_name />
      <div
        v-for="(ancillaries, ancillaries_index) in ancillaries_by_traveler[
          traveler.id
        ]"
        :key="`${_uid}:traveler:${traveler.id}:${ancillaries_index}`"
      >
        <div
          v-for="info in ancillaries"
          :key="`${_uid}:traveler:${traveler.id}:${ancillaries_index}:${info.id}`"
          class="booked-ancillaries__entry"
        >
          <span class="semibold">
            {{ info.description }}
          </span>
          <i
            v-for="segment in info.segments || []"
            :key="`${_uid}:traveler:${traveler.id}:${ancillaries_index}:${info.id}:${segment.id}`"
          >
            ({{ segment.departure.iataCode }}
            {{ segment.departure.airportName }}
            -
            {{ segment.arrival.iataCode }}
            {{ segment.arrival.airportName }})
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TravelerLabel from "@liveflight/components/blocks/traveler/traveler-label.vue";
export default {
  name: "booked-ancillaries",
  components: {
    "traveler-label": TravelerLabel,
  },
  props: {
    additional_service: {
      type: Object,
      required: true,
    },
    flight_offer: {
      type: Object,
      required: true,
    },
    travelers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ancillaries_info() {
      return this.additional_service.info || {};
    },
    travelers_with_ancillaries() {
      return this.travelers.filter(
        (traveler) => this.ancillaries_by_traveler[traveler.id],
      );
    },
    segments() {
      const { itineraries = [] } = this.flight_offer || {};
      return itineraries.flatMap((itinerary) => itinerary.segments || []);
    },
    ancillaries_by_traveler() {
      const { travelerPricings = [] } = this.flight_offer || {};
      if (!travelerPricings.length) {
        return {};
      }
      return travelerPricings.reduce((mapped, pricing) => {
        const { fareDetailsBySegment } = pricing;
        // Flatten + dedup by ancillary id — one info row that spans
        // multiple fareDetails (e.g. round-trip) should render once.
        const seen = {};
        const ancillaries_flat = [];
        fareDetailsBySegment.forEach((fare) => {
          this.ancillary_by_type(fare).forEach((info) => {
            const { id = "" } = info || {};
            if (!id || seen[id]) return;
            seen[id] = true;
            ancillaries_flat.push(info);
          });
        });
        if (!ancillaries_flat.length) {
          return mapped;
        }
        return {
          ...mapped,
          [pricing.travelerId]: [ancillaries_flat],
        };
      }, {});
    },
  },
  methods: {
    ancillary_by_type(fare) {
      const { additionalServices = [] } = fare || {};
      return additionalServices
        .filter((ancillary) => this.ancillaries_info[ancillary.id])
        .map((ancillary) => {
          const parsed = {
            ...ancillary,
            ...this.ancillaries_info[ancillary.id],
          };
          parsed.segments = this.segments.filter((segment) =>
            (parsed.flightSegments || []).includes(segment.id),
          );
          return parsed;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.booked-ancillaries {
  display: flex;
  flex-direction: column;

  &__item:not(:first-child) {
    border-top: 1px solid $light-gray;
    margin-top: $grid-gutter-width / 6;
    padding-top: $grid-gutter-width / 6;
  }

  &__entry {
    display: flex;
    align-items: center;
    gap: $grid-gutter-width / 6;
    margin-left: $grid-gutter-width / 3;
  }
}
</style>
